// extracted by mini-css-extract-plugin
export default {"transporte":"claim_transporte__OmUzs","transporte_coll":"claim_transporte_coll__8EIFP","claim_all":"claim_claim_all__x4AWl"};